module.exports = __webpack_public_path__ + "static/logo-border-a6d4c435c87bfe31afec55baf12d79dd.jpeg";